import * as React from 'react';

import * as styles from './FormField.css';
import { IFormField } from './types';

export const FormField: React.FC<IFormField> = ({ children, label, description, ...rest }) => (
  <div className={styles['container']} {...rest} data-testid="container">
    {label && <label className={styles['label']}>{label}</label>}
    {description && <p className={styles['description']}>{description}</p>}
    {children}
  </div>
);
